import axios from 'axios';

import { IdentityEndpoints } from '../../constants/identity';
import { getDeviceID } from '../../../utilities/common/device';
import {
  clearAuthTokenData,
  getRefreshToken,
  setTokenData,
  TokenData,
} from '../../../utilities/common/token';
import { clearLocalStorage } from '../../../utilities/common/storage';

const getTokenDataOnExpiry = async (): Promise<TokenData> => {
  try {
    const response = await axios.post(
      IdentityEndpoints.exchangeRefreshToken,
      { refreshToken: getRefreshToken() },
      {
        headers: { deviceId: getDeviceID() },
        withCredentials: true,
      },
    );

    const data = response?.data;
    if (data?.success && data?.data) {
      return data.data as TokenData;
    }
  } catch (error) {
    console.error(error);
    clearAuthTokenData();
    clearLocalStorage();
    window.location.replace('/login');
  }

  throw new Error('Invalid token');
};

let exchangeTokenPromise: Promise<string | null> | null = null;

export const fetchTokenDataOnExpiry = async (): Promise<string | null> => {
  if (!exchangeTokenPromise) {
    exchangeTokenPromise = getTokenDataOnExpiry().then((data) => {
      setTokenData({ ...data });
      return data.accessToken;
    });
  }

  try {
    return await exchangeTokenPromise;
  } finally {
    exchangeTokenPromise = null;
  }
};
